
// 2nd version of the ThemeContext.js file

// import React, { createContext, useContext, useEffect, useState } from "react";
// import { brandColors } from "../brandColors";

// // Create Theme Context
// const ThemeContext = createContext();

// // Helper function to extract brand from manufacturer name
// const extractBrandFromManufacturer = (manufacturerName = "") => {
//   const lowerCaseName = manufacturerName.toLowerCase();
//   return (
//     Object.keys(brandColors).find((brand) =>
//       lowerCaseName.includes(brand.toLowerCase())
//     ) || "Default"
//   );
// };

// // Theme Provider Component
// export const ThemeProvider = ({ children }) => {
    
//   const user = JSON.parse(localStorage.getItem("user"));
//   console.log("Theme Provider user:", user);

//   const userRole = user?.role;

//   // Default brand
//   let brand = "Default";

//   // Only apply theme for DealershipAdmin
//   if (
//     userRole === "DealershipAdmin" &&
//     typeof user?.dealershipId?.manufacturerName === "string"
//   ) {
//     brand = extractBrandFromManufacturer(user.dealershipId.manufacturerName);
//   }

//   // Format brand name (e.g., hyundai => Hyundai)
//   const formattedBrand = brand.charAt(0).toUpperCase() + brand.slice(1);

//   // Get theme color or default
//   const themeColor = brandColors[formattedBrand] || brandColors["Default"];
//   console.log("Theme Color:", themeColor);

//   // State to hold current theme
//   const [theme, setTheme] = useState(themeColor);

//   // Update theme if manufacturer changes
//   useEffect(() => {
//     setTheme(themeColor);
//   }, [themeColor]);

//   return (
//     <ThemeContext.Provider value={theme}>
//       {children}
//     </ThemeContext.Provider>
//   );
// };

// // Custom hook to use theme
// export const useTheme = () => useContext(ThemeContext);


//3rd version of the ThemeContext.js file

import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { brandColors } from "../brandColors";

// Create Theme Context
const ThemeContext = createContext();

// Helper function to extract brand from manufacturer name
const extractBrandFromManufacturer = (manufacturerName = "") => {
  const lowerCaseName = manufacturerName.toLowerCase();
  return (
    Object.keys(brandColors).find((brand) =>
      lowerCaseName.includes(brand.toLowerCase())
    ) || "Default"
  );
};

// Theme Provider Component
export const ThemeProvider = ({ children }) => {
  const user = useSelector((state) => state.auth.user); // 👈 use Redux instead of localStorage
  console.log("Theme Provider user (from Redux):", user);

  const userRole = user?.role;
    console.log("User Role:", userRole);

  let brand = "Default";

  if (userRole === "DealershipAdmin" && typeof user?.dealershipId?.manufacturerName === "string") {
    brand = extractBrandFromManufacturer(user.dealershipId.manufacturerName);
  }

  const formattedBrand = brand.charAt(0).toUpperCase() + brand.slice(1);
  const themeColor = brandColors[formattedBrand] || brandColors["Default"];
  console.log("Theme Color:", themeColor);

  const [theme, setTheme] = useState(themeColor);

  useEffect(() => {
    setTheme(themeColor);
  }, [themeColor]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use theme
export const useTheme = () => useContext(ThemeContext);
